import { render, staticRenderFns } from "./SearchSealComponent.vue?vue&type=template&id=2d12f95a&"
import script from "./SearchSealComponent.vue?vue&type=script&lang=js&"
export * from "./SearchSealComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports